import { Modal } from "@mui/material";
import styled from "styled-components";

export const ButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 8px;
`;
